import { API_AUTH } from "./common";

const QuanLyThuChiHopDongApi = {
  list: ({
    tuNgay,
    denNgay,
    ten,
    nhanvien,
    kieuvay,
    loaithuchi,
    tinhtrangno,
    kenhthanhtoan,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `thu-chi-hop-dong/danh-sach-thu-chi-hop-dong?tungay=${tuNgay}&denngay=${denNgay}&ten=${ten}&nhanvien=${nhanvien}&kieuvay=${kieuvay}&loaithuchi=${loaithuchi}&tinhtrangno=${tinhtrangno}&kenhthanhtoan=${kenhthanhtoan}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),


    listthuchilandonglai: (
      chovayId,
      pageIndex,
      pageSize,
    ) =>
      API_AUTH.get(
        `thu-chi-hop-dong/danh-sach-thu-chi-lan-dong-lai-hop-dong?chovayId=${chovayId}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
        {}
      ),


  xoaPhieuThuChi: (thuChiId) => {
    return API_AUTH.post(
      `thu-chi-hop-dong/xoa-thu-chi-hop-dong?thuChiId=${thuChiId}`,
      {}
    );
  },

  editThuNgoaiHopDong: (
    thuchiId,
    ngaythuchi,
    nguoithanhtoan,
    tienthanhtoan,
    phikho,
    phikhac,
    ghichu,
    kenhthanhtoan
  ) =>
    API_AUTH.post(
      `thu-chi-hop-dong/sua-phieu-thu?thuchiId=${thuchiId}&ngaythuchi=${ngaythuchi}&nguoithanhtoan=${nguoithanhtoan}
      &tienthanhtoan=${tienthanhtoan}&phikho=${phikho}&phikhac=${phikhac}&ghichu=${ghichu}&kenhthanhtoan=${kenhthanhtoan}`,
      {}
    ),


    editThuNgoaiHopDong1: (
      thuchiId,
      ngaythuchi,
      nguoithanhtoan,
      tienthanhtoan,
      phikho,
      phikhac,
      phatdonglai,
      ghichu,
      kenhthanhtoan
    ) =>
      API_AUTH.post(
        `thu-chi-hop-dong/sua-phieu-thu1?thuchiId=${thuchiId}&ngaythuchi=${ngaythuchi}&nguoithanhtoan=${nguoithanhtoan}
        &tienthanhtoan=${tienthanhtoan}&phikho=${phikho}&phikhac=${phikhac}&phatdonglai=${phatdonglai}&ghichu=${ghichu}&kenhthanhtoan=${kenhthanhtoan}`,
        {}
      ),


    checkXoaThuChiHopDong: (thuChiId) => {
      return API_AUTH.get(
        `thu-chi-hop-dong/check-xoa-thu-chi-hop-dong?thuchiId=${thuChiId}`,
        {}
      );
    },
};

export default QuanLyThuChiHopDongApi;
